import { Inject, Injectable, Injector, LOCALE_ID } from '@angular/core';
import { LoaderSpinnerTypes } from '@carm/_core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IDocumentList } from '../models/document-list.model';

@Injectable()
export class DocumentsCollectionLettersService extends BaseApiService { // Documents - Collection Letters controller
  constructor(
    protected injector: Injector,
    @Inject(LOCALE_ID) protected localeId: string
  ) {
    super(injector);
  }
  get documentBEndpoint(): string {
    return `${this.endPointB}/documents`;
  }

  public getLettersList(
    selectedTab: string,
    minDate: Date,
    maxDate: Date
  ): Observable<IDocumentList> {
    const endPoint = `${this.documentBEndpoint}/${selectedTab}/list`;
    return this.httpAuthGet<IDocumentList>(endPoint, null, LoaderSpinnerTypes.AgGrid);
  }

  public getDocument(selectedTab: string, docId: string): Observable<Blob> {
    const endPoint = `${this.documentBEndpoint}/${selectedTab}/${docId}/download`;
    return this.httpAuthDownloadFile(endPoint);
  }

}
